import { ArrowRightOutlined } from "@ant-design/icons"
import { ComponentConfig } from "@measured/puck"
import { Modal } from "antd"
import { useState } from "react"
import { configs, DefaultImage } from "../../../../external-components"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import "./style.css"

export interface CardProps {
  img?: string
  name?: string
  position?: string
  description?: string
  link?: string
}

export interface CardProfile extends CommonStylesProps {
  mailTo?: string
  items: CardProps[]
}

export const RenderConfig: ComponentConfig<CardProfile> = {
  render: ({ items, mailTo }) => {
    const currentPath = window.location.pathname
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [selectedItem, setSelectedItem] = useState<CardProps | null>(null)

    const handleItemClick = (item: CardProps) => {
      setSelectedItem(item)
      setIsModalOpen(true)
    }

    const handleModalClose = () => {
      setIsModalOpen(false)
      setSelectedItem(null)
    }

    return (
      <>
        <div className="grid sm:grid-cols-4 grid-cols-1 gap-10">
          {items &&
            items.map((item, index) => (
              <div key={index} className="rounded-xl gap-6 cursor-pointer" onClick={() => handleItemClick(item)}>
                <img
                  src={item.img ? `${configs.API_URL}${item.img}` : DefaultImage}
                  alt={`Slide ${index}`}
                  className="w-full h-[270px] object-cover rounded-xl"
                />
                <p className="text-[24px] leading-[28px] font-semibold text-[#242F3E] pt-4 pb-3">{item.name}</p>
                <p className="text-base leading-[22px] font-normal text-[#4F4F4F]">{item.position}</p>
              </div>
            ))}
        </div>

        <Modal
          open={isModalOpen}
          onCancel={handleModalClose}
          footer={null}
          width={789}
          centered
          style={{ borderRadius: "16px" }}
          maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
        >
          <div className="flex sm:flex-row flex-col gap-10 sm:p-10 pt-[56px] pb-6 px-4">
            <div className="flex flex-col items-center sm:w-[43%] w-full gap-6">
              <img
                src={selectedItem?.img ? `${configs.API_URL}${selectedItem.img}` : DefaultImage}
                alt={selectedItem?.name}
                className="w-full h-[270px] object-cover rounded-2xl"
              />
              <button
                className="flex items-center gap-2 px-3 py-2 bg-[#0B9444] text-white text-base leading-[22px] font-semibold rounded-[100px] border border-[#0B9444] shadow-lg shadow-[#0000000D] transition-all duration-300 hover:bg-white hover:text-[#0B9444] hover:border-[#0B9444] group"
                onClick={() => {
                  setTimeout(() => {
                    window.open(`mailto:${mailTo}`, "_blank")
                  }, 1000)
                }}
              >
                Drop an Email
                <ArrowRightOutlined className="rounded-full p-2 bg-white text-[#0B9444] transition-all duration-300 group-hover:bg-[#0B9444] group-hover:text-white" />
              </button>
            </div>
            <div className="sm:w-[57%] w-full">
              <p className="text-2xl leading-[28px] font-semibold text-[#0B9444]">{selectedItem?.name}</p>
              <p className="text-base leading-[22px] font-normal text-[#242F3E] pt-3 pb-4">{selectedItem?.position}</p>
              <p className="sm:text-[15px] text-sm leading-[21px] font-light text-[#242F3E] overflow-hidden sm:overflow-y-hidden overflow-y-auto sm:line-clamp-0 line-clamp-11 max-h-[231px]">
                {selectedItem?.description}
              </p>
            </div>
          </div>
        </Modal>
      </>
    )
  },
}
